import { writeMidi } from 'midi-file';

export const downloadMidi = (midi, name) => {
   const midiArray = new Uint8Array(writeMidi(midi));

   const blob = new Blob([midiArray], { type: 'audio/midi' });

   const link = document.createElement('a');
   link.href = window.URL.createObjectURL(blob);
   link.download = name;
   link.click();
};
